import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage'
const Storage = Platform.OS === 'web' ? window.sessionStorage : AsyncStorage;

const sitePrefix = 'zufang_'
const _cacheFlagKey = 'Cache_Flag'

const isWebJD = () => {
  if(Platform.OS === 'web'){
      return navigator.userAgent.toLowerCase().indexOf('jdapp') > -1;
  } else {
      return false
  }
};

export const CACHE_KEY_FLAG = `${sitePrefix}${_cacheFlagKey}`;
let _clearCacheTimer = null
export const CacheKeyEnum = {
  recommend_List: sitePrefix + 'recommend_List',
  positionInfo_List: sitePrefix + 'positionInfo_List',
  isPositionSucc_List: sitePrefix + 'isPositionSucc_List', 
  nowPageNo_List: sitePrefix + 'nowPageNo_List',
  pageScrollY_List: sitePrefix + 'pageScrollY_List',

  positionInfo_Home: sitePrefix + 'positionInfo_Home',
  isPositionSucc_Home: sitePrefix + 'isPositionSucc_Home',
  swiperData_Home: sitePrefix + 'swiperData_Home',
  bannerList_Home: sitePrefix + 'bannerList_Home',
  cityInfo_Home: sitePrefix + 'cityInfo_Home',

  cityList_Info: 'cityList_Info',
  cityList_ABC: 'cityList_ABC',
  

}

export const cacheUtil = {
  /**
   * 设置缓存数据
   * @param {String} cacheKey 缓存key
   * @param {Any} cacheData 缓存值,值不设置，代表清空cackeKey
   * @param {Boolean} isWebOnly 缓存是否只在web环境生效，默认true
   */
  setCache: (cacheKey, cacheData, isWebOnly = true) => {
    if((isWebOnly && Platform.OS != 'web') || !cacheKey || isWebJD()) 
      return;

    try{
      if(cacheData){
        Storage.setItem(cacheKey, JSON.stringify(cacheData));
      } else {
        Storage.removeItem(cacheKey);
      }
    } catch(err){
      Storage.removeItem(cacheKey);
    }
  },
  /**
   * 获取缓存数据，缓存时效30分钟
   * @param {*} cacheKey 
   * @param {*} checkFlag 是否需要检查缓存标识， 默认：true 
   */
  getCache: (cacheKey) => {
    if(!cacheKey) 
      return null
    try{
      let cacheData = Storage.getItem(cacheKey);
      return cacheData ? JSON.parse(cacheData) : null;
    } catch(err){
      console.log(`getCache ${cacheKey}`, err)
    }

    return null;
  },
  /**
   * 设置缓存标识：在web环境，页面跳转时需要设置
   */
  setCacheFlag: (myFlag) => {
    if(Platform.OS != 'web' || isWebJD()) 
      return
    
    const cackeKey = CACHE_KEY_FLAG + myFlag;
    _clearCacheTimer && clearTimeout(_clearCacheTimer)
    try {
      Storage.setItem(cackeKey, JSON.stringify(Date.now()));
    } catch (err) {
      console.log(err);
    }
  },
  /**
   * 设置缓存标识：在web环境，页面跳转时需要设置
   */
  getCacheFlag: (myFlag) => {
    if(Platform.OS != 'web' || isWebJD()) 
      return false
    
    try {
      let cacheFlag = Storage.getItem(CACHE_KEY_FLAG + myFlag);
      cacheFlag = JSON.parse(cacheFlag || '0');
      return cacheFlag && (Date.now() - cacheFlag) <= 30 * 60 * 1000; // 只使用30分钟之内的缓存
    } catch (err) {
      console.log(err);
    }
    return false
  },
  /**
   * 清空缓存标识：web环境，页面回退时，需要用缓存数据渲染
   * 所有组件渲染完毕，清空缓存标识，暂时通过定时器处理
   */
  clearCacheFlag: (myFlag) => {
    if(Platform.OS != 'web') 
      return
    
    _clearCacheTimer = setTimeout(() => {
      Storage.removeItem(CACHE_KEY_FLAG + myFlag);
        Object.keys(CacheKeyEnum).forEach(key => {
          Storage.removeItem(CacheKeyEnum[key]);
        })
    }, 150);
  }
}